module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPBAMAAADJ+Ih5AAAAMFBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABaPxwLAAAAEHRSTlMAKp1Un6VyWT+LfWZMOhsVkyDgFwAAAExJREFUCNdjAAOeuQwQYGJ6AUwzhzFPgAg0pRwACzhyBEMEBEQMIAKMzmABEagAQzZUgD9iC0SAPTSRAcKoZ0AFDwXB4AHDIiUwWAAAcHwOMo6RXtAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-edit.png
// module id = 1300
// module chunks = 3